const theme = {};

theme.palette = {
    bg: 'rgba(18, 61, 84, 1.0)',
    footer: 'rgba(3, 3, 13, 1.0)',
    blue: "rgba(208, 239, 255, 1.0)",
    orange: "rgba(245, 126, 32, 1.0)",
};

theme.sizes = {
    baseSpace: 16,
    baseFont: 17,
    baseLine:  1,
    baseRadius: 5,
}

export default theme;



// WEBPACK FOOTER //
// ./src/utils/themes/main.js